import type { RemindMeRequest } from "@/modules/eventDetails/client/api/types"
import type { UseMutationResult } from "@tanstack/react-query"

import { useMutation } from "@tanstack/react-query"

import { getRemindMe } from "@/modules/eventDetails/client/api/getRemindMe"

export const useRemindMe = (): UseMutationResult<void, Error, RemindMeRequest> =>
  useMutation<void, Error, RemindMeRequest>({ mutationFn: getRemindMe })
